import { render } from "./AltaTkt.vue?vue&type=template&id=69a96770"
import script from "./AltaTkt.vue?vue&type=script&lang=js"
export * from "./AltaTkt.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__